<section class="w-full flex justify-center my-14">
	<div *ngIf="isLoading"
		 class="container flex flex-col items-center justify-center gap-2">
		<h1 class="text-3xl font-medium">Your Email is being verified. Please wait</h1>
		<img ngSrc="./assets/img/email_verified.jpg" width="612" height="490"/>
		<a routerLink="/auth" >
			< Go to Sign In
		</a>
	</div>
	<ng-container *ngIf="!isLoading">
		<div *ngIf="emailVerified"
			 class="container flex flex-col items-center justify-center gap-2">
			<h1 class="text-2xl font-medium">Your Email is Verified</h1>
			<img ngSrc="./assets/img/email_verified.jpg" width="612" height="490"/>
			<p>
				Your email is verified. Now you can sign in.
			</p>
			<a routerLink="/auth" >
				< Go to Sign In
			</a>
		</div>

		<div *ngIf="!emailVerified"
			 class="container flex flex-col items-center justify-center gap-2">
			<h1 class="text-2xl font-medium text-red-500">Your Email is Not Verified</h1>
			<img ngSrc="./assets/img/verification_failed.png" width="428" height="396"/>
			<p>
				Your email is not verified. Please verify and try again.
			</p>
			<a routerLink="/auth/email-verification" >
				< Go to Email Verification
			</a>
		</div>
	</ng-container>
</section>
